import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ListItemIcon, ListItemText, MenuItem, Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { Lock } from "@material-ui/icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { withFirebase } from "../Firebase";

const ChangePasswordMenuItem = ({ firebase, close }) => {
  const { t } = useTranslation();
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");

  const sendMail = () => {
    firebase
      .sendPasswordEmail(firebase.currentUser().email)
      .then(() => {
        setError(false);
        setMessage("checkEmail");
        setOpenSnackBar(true);
      })
      .catch((error) => {
        setError(true);
        setMessage("auth." + error.code);
        setOpenSnackBar(true);
      });
  };

  return (
    <>
      <MenuItem button onClick={() => sendMail()}>
        <ListItemIcon>
          <Lock color={"primary"} />
        </ListItemIcon>
        <ListItemText>{t("changePassword")}</ListItemText>
      </MenuItem>
      <Dialog open={openSnackBar}>
        <DialogTitle id="simple-dialog-title">{t("resetPassword")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t(message)}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenSnackBar(false);
              close();
            }}
          >
            {t("aceptar")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default withFirebase(ChangePasswordMenuItem);
